<div [id]="id">
    <label [attr.for]="valueId">{{ label }}</label>
    <span [id]="valueId">{{ display }}</span>
</div>